import { EraserTool } from "./tools/EraserTool/EraserTool.mjs";
import { HandTool } from "./tools/HandTool/HandTool.mjs";
import { LaserTool } from "./tools/LaserTool/LaserTool.mjs";
import { SelectTool } from "./tools/SelectTool/SelectTool.mjs";
import { ZoomTool } from "./tools/ZoomTool/ZoomTool.mjs";
const defaultTools = [EraserTool, HandTool, LaserTool, ZoomTool, SelectTool];
export {
  defaultTools
};
//# sourceMappingURL=defaultTools.mjs.map
